export default __webpack_public_path__ + "static/media/DAPAVIRADA.266a23f9.jpg";